export default __webpack_public_path__ + "assets/media/favicon196.282c8286dce1b4fbac7202978daf4331.png";